import { get } from '@core/api/baseApi';
import { Template } from '@core/types';

export const getTemplate = (templateId: string): Promise<Template> => get(`/ReportTemplates/${templateId}`);
